var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { formatCurrency, formatDisplayDateWithFormat, getLanguageFromStorage } from 'syf-js-utilities';
import useTranslation from '../../../hooks/use-translation';
import { StyledFlex, StyledText } from '../../subcomponents';
var dateFormatOptions = {
    day: '2-digit',
    month: 'numeric',
    year: 'numeric'
};
var Installments = function (_a) {
    var installments = _a.installments;
    var currentLanguage = getLanguageFromStorage();
    var i18n = useTranslation();
    return (_jsx(_Fragment, { children: installments.map(function (_a) {
            var installmentAmount = _a.installmentAmount, paymentDueDate = _a.paymentDueDate, sequence = _a.sequence;
            return (_jsxs(StyledFlex, __assign({ justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(StyledText, __assign({ align: "left", weight: "semiBold", size: "medium" }, { children: formatCurrency(installmentAmount) })), _jsxs(StyledText, __assign({ align: "right", weight: "semiBold", size: "regular" }, { children: [i18n('settlement.cardDetailsDueByText'), ' ', formatDisplayDateWithFormat(paymentDueDate, 'MM/dd/yyyy')] }))] }), sequence));
        }) }));
};
export default Installments;
//# sourceMappingURL=index.js.map